import Icon from '../components/Icon.vue'

Icon.register({
  ad: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M157.5 272H194.5L176 218.8 157.5 272zM352 256C338.8 256 328 266.8 328 280S338.8 304 352 304 376 293.2 376 280 365.2 256 352 256zM464 64H48C21.5 64 0 85.5 0 112V400C0 426.5 21.5 448 48 448H464C490.5 448 512 426.5 512 400V112C512 85.5 490.5 64 464 64zM250.6 352H233.6C226.8 352 220.8 347.7 218.5 341.3L211.2 320H140.9L133.5 341.3A16-16 0 0 0 118.4 352H101.4C90.4 352 82.7 341.1 86.3 330.8L140 176.1A24-24 0 0 0 162.7 160H189.3A24-24 0 0 0 212 176.1L265.7 330.8C269.3 341.1 261.6 352 250.6 352zM424 336C424 344.8 416.8 352 408 352H392C387.1 352 383 349.7 380 346.3 371.4 350 361.9 352 352 352 312.3 352 280 319.7 280 280S312.3 208 352 208C360.5 208 368.5 209.7 376 212.4V176C376 167.2 383.2 160 392 160H408C416.8 160 424 167.2 424 176V336z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ad.js
// module id = 9Def
// module chunks = 144